import React from "react";
import { Button } from "@mui/material";
import LdapTestFormDialog from "./LdapTestFormDialog";
import { FormattedMessage } from "react-intl";

const LDAPTestButton: React.FC<{ formValues: Record<string, any> }> = ({ formValues }) => {
    const [dialogOpen, setDialogOpen] = React.useState(false);
    return (
        <>
            <Button
                color="secondary"
                onClick={() => {
                    setDialogOpen(true);
                }}
            >
                <FormattedMessage id="ldap_test_form.open" defaultMessage="Open test form" />
            </Button>
            <LdapTestFormDialog open={dialogOpen} serverData={formValues} hide={() => setDialogOpen(false)} />
        </>
    );
};

export default LDAPTestButton;
